__turbopack_context__.v({
  "icon_button": "hXffKW_icon_button",
  "no_outline": "hXffKW_no_outline",
});
